React = require 'react'
{ withRouter } = require 'react-router-dom'
ReactBacon = require 'react-bacon'
R = require 'ramda'
moment     = require 'moment'
{ Icon }= require 'react-fa'
cx = require 'classnames'
PropTypes = require 'prop-types'
createReactClass = require 'create-react-class'

resUtil = require 'utils/resources'
OrderUtils = require './components/utils'
AssignDriverPopup = require './drivers/assign_driver_popup'
CancelDelivery = require './drivers/cancel_delivery'

optimisticStore = require 'models/list-optimistic'

{ UserIs, UserIsNot, orderActionLabel } = OrderUtils
{ orderActionLabel } = OrderUtils

{ Button, Modal, ModalFooter, ModalHeader, ModalBody, ModalTitle, Form,  Label, Input, ButtonGroup, ButtonToolbar, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, FormText, FormGroup } = require 'reactstrap'
userStore = require 'stores/user'


formatTimeWithOffset = (offset, m) ->
  if offset != null
    m.utcOffset offset
    "#{m.fromNow()} - #{m.format('llll')}"
  else
    "#{m.fromNow()}"

ConfirmModalForm = createReactClass
  displayName: 'ConfirmModalForm'
  propTypes:
    order: PropTypes.object.isRequired
    onSubmit: PropTypes.func.isRequired
    onCancel: PropTypes.func.isRequired

  getInitialState: ->
    customDelay: null

  setDelay: (delay) ->
    @props.onSubmit duration: delay

  onSetCustomDelay: ->
    delay = parseInt @state.customDelay
    if !isNaN(delay) and delay >= 0 and delay <= 120
      @props.onSubmit duration: delay

  onUpdateCustomDelay: (delay)->
    @setState customDelay: delay

  _parseTime: (order) ->
    value = order.time.value
    if order.time && order.time.estimation
      estimatedValue = order.time.estimation.delivery || order.time.estimation.pickup
      if estimatedValue && moment(moment(value)).isBefore(moment(estimatedValue))
        value = estimatedValue
    return value

  _renderCurrentTime: (order) ->
    formatTime = R.partial(formatTimeWithOffset, [@props.restaurant.timezone.offset])
    value = @_parseTime(order)
    m = moment Date.parse value
    return formatTime(m)

  _renderFutureTime: (order) ->
    formatTime = R.partial(formatTimeWithOffset, [@props.restaurant.timezone.offset])
    value = @_parseTime(order)
    m = moment Date.parse value
    if @state.customDelay
      return formatTime(m.add(@state.customDelay, 'minutes'))
    else
      return formatTime(m)

  onClose: ->
    @props.onCancel()

  render: ->
    bsStyleForCustomDelay = (delay) ->
      if delay == null
        'secondary'
      else if isNaN parseInt delay
        'error'
      else if parseInt(delay) < 0 or parseInt(delay) > 90
        'error'
      else
        'success'

    buttons = R.map (delay) =>
      <Button key={delay} color="success" onClick={R.partial(@onUpdateCustomDelay, [delay])}>{delay}</Button>
    , [0, 5, 10, 15, 20, 25, 30, 45, 60, 75, 90]

    <Modal isOpen onClosed={@onClose}>
      <ModalHeader>
        Order Confirmation {@props.order.customer.name} -ASAP- {@props.order.service.label}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Input plaintext className="col-xs-10 col-xs-offset-2" style = {fontWeight: "bold", textAlign: "center"}> Add Additional time for your ASAP Order </Input>
            <Label className ='col-xs-2'>Current due: {@_renderCurrentTime(@props.order)}</Label>
            <Input plaintext className="col-xs-10 col-xs-offset-2" style = {fontWeight: "bold"}> Pick Duration: </Input>
            <FormText color="muted">Click on the additional time options below (This time would be added in your due time)</FormText>
            <ButtonGroup>{buttons}</ButtonGroup>
            <FormText color="muted">Updated Due time: {@_renderFutureTime(@props.order)}</FormText>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color={bsStyleForCustomDelay(@state.customDelay)} className={cx('hidden': bsStyleForCustomDelay(@state.customDelay) != "success")} onClick={@onSetCustomDelay}>Save Duration & Confirm</Button>
        <Button color="danger" onClick={@onClose}>Close</Button>
      </ModalFooter>
    </Modal>


iconForAction = (action) ->
  switch action.name
    when 'confirm' then React.createElement(Icon, {"name": "check"})
    when 'cancel' then React.createElement(Icon, {"name": "trash-o"})
    when 'miss' then React.createElement(Icon, {"name": "refresh"})
    when 'prepare' then React.createElement(Icon, {"name": "check"})

labelForAction = (action) ->
  switch action.name
    when 'confirm' then 'Confirm'
    when 'cancel' then 'Cancel'
    when 'touch' then 'Touch'
    when 'execute' then 'Execute'
    when 'prepare' then 'Prepare'
    else action.name

buttonStyleForAction = (action) ->
  switch action.name
    when 'confirm' then 'primary'
    when 'cancel' then 'danger'
    when 'prepare' then 'primary'
    else 'secondary'

defaultOrderActions =
  restaurantPhone: "Restaurant notified by phone"
  restaurantEmail: "Restaurant notified by email"
  restaurantNA: "Restaurant not answering"
  refundTicketCreated: "Refund ticket created"
  userNotified: "User notified"
  userNA: "User not answering"
  custom: "[Enter Custom Message]"

messageFromEvent = (eventId) ->
  defaultOrderActions[eventId]

disableCancel = R.curry (hasRestrictedRole, action) ->
  !(hasRestrictedRole and action.name == 'cancel')


ModifyTipModal = createReactClass
  displayName: 'ModifyTipModal'

  propTypes:
    order: PropTypes.object.isRequired
    onCancel: PropTypes.func.isRequired
    onSubmit: PropTypes.func.isRequired

  getInitialState: ->
    tip: 0

  toggle:->
    @props.onCancel()
  
  updateTipValue: (event) ->
    @setState tip: event.target.value

  onSubmit: ->
    @props.onSubmit name: "tip", amount: @state.tip*100

  render: ->
    <Modal isOpen>
      <ModalHeader toggle={@toggle}>
        [{@props.order.restaurant.name}] Modify Tip for {@props.order.customer.name}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Originial Tip</Label>
            <Input type = "number" name="default-tip" value={@props.order.tip.value/100} disabled>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Set Tip</Label>
            <Input type = "number" name="custom-tip" value={@state.tip} onChange = {(e) => @updateTipValue(e)}>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick = {@onSubmit}> Submit</Button>
        <Button color="danger" onClick = {@toggle}>Close</Button>
      </ModalFooter>
    </Modal>

ModifyOrderModal = createReactClass
  displayName: 'ModifyOrderModal'

  propTypes:
    order: PropTypes.object.isRequired
    onCancel: PropTypes.func.isRequired
    onSubmit: PropTypes.func.isRequired

  getInitialState: ->
    amount: 0
    type: "recharge"
    reason: ""
    validReason: null

  toggle:->
    @props.onCancel()
  
  updateOrderValue: (event) ->
    @setState amount: event.target.value

  updateTypeValue: (event) ->
    @setState type: event.target.value 

  updateReasonValue: (event) ->
    @setState {reason: event.target.value, validReason: true }

  onSubmit: ->
    if @state.reason == ""
      @setState validReason: false
    else
      @props.onSubmit name: "total", delta: @state.amount*100, type: @state.type, reason: @state.reason

  _inputReason: () ->
    if @state.validReason == false
      <Input type="text" placeholder="reason for modification" onChange = {(e) => @updateReasonValue(e)} invalid />
    else
      <Input type="text" placeholder="reason for modification" onChange = {(e) => @updateReasonValue(e)}></Input>

  render: ->
    <Modal isOpen>
      <ModalHeader toggle={@toggle}>
        [{@props.order.restaurant.name}] Modify Order for {@props.order.customer.name}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Amount</Label>
            <Input type = "number" required name="default-Order" value={@state.amount} onChange = {(e) => @updateOrderValue(e)}>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Type</Label>
            <Input type="select" name="type" onChange = {(e) => @updateTypeValue(e)}>
            <option>recharge</option>
            <option>refund</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Reason: </Label>
            {@_inputReason()}
          </FormGroup>
        <Button color="success" onClick = {@onSubmit}> Submit</Button>
        <Button color="danger" onClick = {@toggle}>Close</Button>
        </Form>
      </ModalBody>
      <ModalFooter>
        
      </ModalFooter>
    </Modal>


OrderToolbar = createReactClass
  displayName: 'OrderToolbar'

  mixins: [ReactBacon.BaconMixin]

  propTypes:
    model: PropTypes.object.isRequired
    rdsOrder: PropTypes.object
    order: PropTypes.object.isRequired
    actions: PropTypes.array.isRequired
    notifications: PropTypes.array.isRequired

  componentWillMount: ->
    @plug @props.model.reloadingOrder, 'reloading'
    @plug @props.model.executingCreateManualEvent, 'executingCreateManualEvent'
    @plug @props.model.executingNotificationAction, 'executingNotificationAction'
    @plug @props.model.orderState, 'orderState'

  getInitialState: ->
    currentActionForm: null
    reloading: false
    executingCreateManualEvent: false
    executingNotificationAction: false
    notifyDropdown: false
    printDropdown: false
    orderDropdown: false


  onOrderAction: (action) ->
    switch action.name
      when 'confirm'
        if @props.order.time.id == 'ASAP'
          submit = (params) =>
            @props.model.executeAction action, params
            optimisticStore.updateOrderState @props.order, 'confirmed'
            @setState currentActionForm: null
            @props.history.goBack() if userStore.settingFor 'go-back-after-confirm'
          cancel = =>
            @setState currentActionForm: null
          @setState currentActionForm: React.createElement(ConfirmModalForm, {"onSubmit": (submit), "onCancel": (cancel), "order": (@props.order), "restaurant": (@props.restaurant)})
        else
          @props.model.executeAction action
          optimisticStore.updateOrderState @props.order, 'confirmed'
          @props.history.goBack() if userStore.settingFor 'go-back-after-confirm'
      when 'cancel'
        if confirm "Are you sure you want to cancel this order?"
          @props.model.executeAction action
          optimisticStore.updateOrderState @props.order, 'canceled'
          @props.history.goBack() if userStore.settingFor 'go-back-after-confirm'
      else
        @props.model.executeAction action
        @props.history.goBack() if userStore.settingFor 'go-back-after-confirm'

  onReloadOrder: ->
    @props.model.reload()

  onModifyTip: (orderId)->
    submit = (params) =>
      action = {
        name: "modify-tip",
        interactive: true,
        url: "#{ORDERS_SVC}/v4/orders/#{orderId}/adjustments.json"
        }
      if params.amount > 0
        @props.model.executeAdjustment action, params
      else
        alert "Invalid Tip Amount"
      @setState currentActionForm: null
    cancel = =>
      @setState currentActionForm: null
    @setState currentActionForm: React.createElement(ModifyTipModal, {"onSubmit": (submit),"onCancel": (cancel), "order": (@props.order)})

  onSendDispute: (orderId)->
    action = {
      name: "send-dispute",
      interactive: true,
      url: "#{ORDERS_SVC}/webhooks/midigator/order/#{orderId}"
      }
    @props.model.executeAdjustment action, null

  onModifyOrder: (orderId)->
    submit = (params) =>
      action = {
        name: "modify-order",
        interactive: true,
        url: "#{ORDERS_SVC}/v4/orders/#{orderId}/adjustments.json"
        }
      orderTotal = @props.order.totals.total
      if params.delta >= 0
        if params.type == 'refund' && R.subtract(@props.order.totals.total/100, params.delta/100) < 0
          alert "Hey, Max Refund Amount allowed for this order is: #{@props.order.totals.total/100} and amount entered is #{params.delta/100}"
          return
        @props.model.executeAdjustment action, params
      else
        alert "Invalid Amount"
      @setState currentActionForm: null
    cancel = =>
      @setState currentActionForm: null
    @setState currentActionForm: React.createElement(ModifyOrderModal, {"onSubmit": (submit),"onCancel": (cancel), "order": (@props.order)})

  executeNotificationAction: (action, event) ->
    @props.model.executeNotificationAction resUtil.findResourceLink(action, 'send', 'put'), 'put'

  createManualEvent: (eventId, event) ->
    switch eventId
      when 'custom'
        message = prompt "Enter your message:"
      else
        message = messageFromEvent eventId
    eventsURI = resUtil.findResourceLink @props.order, "events", "get" # TODO: Switch to POST
    if eventsURI
      @props.model.createManualEvent eventsURI, message

  onManualCheckin: (orderId) ->
    status = if @state.orderState then @state.orderState.state else "n/a"
    version = @props.order.carts[0].version
    if status in ['confirmed', 'prepared', 'delivered', 'invoiced'] and version == 5
      checkinURI = "#{LOYALTY_SVC}/v5/orders/#{orderId}/completed"
      @props.model.createManualCheckin checkinURI
    else
       alert "Order Must Be in Confirmed State and Placed via web5 to be able to Checkin"

  toggleNotifyDropdown: ->
    @setState notifyDropdown: not (@state.notifyDropdown)

  toggleAddOrderDropdown: ->
    @setState orderDropdown: not (@state.orderDropdown)

  togglePrintDropdown: ->
    @setState printDropdown: not (@state.printDropdown)

  render: ->
    order = @props.order

    <ButtonToolbar className="order-toolbar">
      { @_renderOrderActions(order) }
      <ButtonGroup>
        { @props.children }
      </ButtonGroup>
      { @_renderOrderAdditionalActions(order) }
    </ButtonToolbar>

  _renderOrderActions: (order) ->
    orderActive = cx 'main-actions', 'hidden': !order
    buttons = R.map (action) =>
      label = labelForAction action
      icon = iconForAction action
      bsStyle = buttonStyleForAction action
      if label
        <Button key={action.name} color={bsStyle} onClick={R.partial(@onOrderAction, [action])}>{icon} {label}</Button>
      else
        null
    , R.filter disableCancel(!userStore.hasAnyRole('config', 'restaurant_admin', 'restaurant', 'restaurant_staff')), @props.actions

    <ButtonGroup className={orderActive}>
      {buttons}
      { @state.currentActionForm }
    </ButtonGroup>

  _renderOrderAdditionalActions: (order) ->
    rdsOrder = @props.rdsOrder
    orderURL = "#{ORDERS_SVC}/channels/#{order.channel.permalink}/restaurants/#{order.restaurant.permalink}/orders/#{order.id}/fax?direct_print=true"
    receiptURL = "#{ORDERS_SVC}/channels/#{order.channel.permalink}/restaurants/#{order.restaurant.permalink}/orders/#{order.id}/print.html?direct_print=true"

    reloadingIndicator = null
    if @state.reloading
      reloadingIndicator = <Icon name="spinner" spin={true} />

    executingToBsStyle = (busy) ->
      if busy then 'warning' else 'secondary'

    orderActionsToMenuItem = R.mapObjIndexed (label, key, obj) =>
      <DropdownItem onClick = {(e) => @createManualEvent(key,e)} key={key}>{label}</DropdownItem>

    manualActions = R.partial orderActionsToMenuItem, [defaultOrderActions]

    <ButtonGroup>
      {!@props.usesPayments2 && @renderModifyTip(@props.order.id)}
      {!@props.usesPayments2 && @renderModifyOrder(@props.order.id)}
      {@renderManualCheckin(@props.order.id)}
      {@renderPrintButtons(orderURL, receiptURL)}
      {@renderDispatcherActions(rdsOrder)}
      {@renderSendDispute(@props.order)}
      <Button key="reload" onClick={@onReloadOrder}>{reloadingIndicator} Reload</Button>
      <UserIs role="restaurant" or="restaurant_staff">
        <Button key="order-action" color={executingToBsStyle(@state.executingNotificationAction)} onClick={() => R.partial @createManualEvent, ['custom', null]}><Icon name="node"/> Add Order Event</Button>
      </UserIs>
      <UserIs role="config" or="restaurant_admin">
        <ButtonDropdown isOpen = {@state.orderDropdown} id="add-order-event" key="order-action"
          color={executingToBsStyle(@state.executingCreateManualEvent)} className="pull-right" toggle = {@toggleAddOrderDropdown}>
          <DropdownToggle>Add Order Event</DropdownToggle>
          <DropdownMenu>
          {R.values manualActions()}
          </DropdownMenu>
        </ButtonDropdown>
      </UserIs>
      {@renderNotifyAgain(order)}
    </ButtonGroup>

  renderNotifyAgain: (order) ->

    actionLabel = R.partial orderActionLabel, [order]

    actionsToButtons = R.map (action) =>
      <DropdownItem onClick={(e) => @executeNotificationAction(action,e)} key={action.id}>{actionLabel(action)}</DropdownItem>

    if userStore.hasAnyRole('config', 'restaurant_staff', 'restaurant_admin', 'restaurant')
      <ButtonDropdown isOpen = {@state.notifyDropdown} id="notify-again" key="notification-actions"
            color={if @state.executingNotificationAction then 'warning' else 'secondary'} className="pull-right" toggle={@toggleNotifyDropdown}>
            <DropdownToggle>Notify Again</DropdownToggle>
            <DropdownMenu>
            {actionsToButtons(@props.notifications)}
            </DropdownMenu>
          </ButtonDropdown>
    else
      null

  renderModifyTip: (orderId) ->
      status = if @state.orderState then @state.orderState.state else "n/a"
      if userStore.hasAnyRole('config', 'restaurant_staff', 'restaurant') && status != 'canceled' && status != 'invoiced'
        <Button color="secondary" onClick = {() => @onModifyTip(orderId)} key="modify-tip"> Modify Tip </Button>
      else
        null

  renderSendDispute: (order) ->
      if order.tender.id == "CARD" && userStore.hasAnyRole('config')
        <Button key="dispute" onClick={(e) => @onSendDispute(order.id)}> Send Dispute </Button>
      else
        null

  renderModifyOrder: (orderId) ->
      status = if @state.orderState then @state.orderState.state else "n/a"
      if userStore.hasAnyRole('config', 'restaurant_admin', 'rds_admin') && status != 'canceled' && status != 'invoiced'
        <Button color="secondary" onClick = {() => @onModifyOrder(orderId)} key="modify-order"> Modify Order </Button>
      else
        null

  renderManualCheckin: (orderId) ->
      if userStore.hasAnyRole('config')
        <Button color="secondary" onClick = {() => @onManualCheckin(orderId)} key="modify-chekin"> Checkin Order </Button>
      else
        null

  renderPrintButtons: (orderURL, receiptURL) ->
    <ButtonDropdown isOpen = {@state.printDropdown} color="secondary" toggle = {@togglePrintDropdown}>
      <DropdownToggle>{@renderPrintButtonHeader()}</DropdownToggle>
      <DropdownMenu>
        <DropdownItem href={orderURL} target="_blank"><Icon name="file-pdf-o" /> Order</DropdownItem>
        <DropdownItem href={receiptURL} target="_blank"><Icon name="file-text-o" /> Receipt</DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>

  renderPrintButtonHeader: ->
    <span><Icon name="print" /> Print...</span>

  renderDispatcherActions: (rdsOrder) ->
    if rdsOrder && rdsOrder.state not in ['delivered', 'error_state', 'auto_confirmed', 'canceled', 'delivery_canceled', 'error']
      <UserIs role="dispatcher">
        <span>
          <AssignDriverPopup order={@props.order} rdsOrder={@props.rdsOrder}/>
          <CancelDelivery order={@props.order} rdsOrder={@props.rdsOrder}/>
        </span>
      </UserIs>
    else
      null

module.exports = withRouter(OrderToolbar)
